/*jslint sloppy: true*/
/*global getResponsiveBreakpoint: true, isElementInViewport: true, jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
  'use strict';

  // Define Northstar app
  Northstar.menu = {
    menuTimer: null,
    topmenuTimer: null,
    submenuTimer: null,
    searchTimer: null,
    openDelay: 100,
    closeDelay: 400,
    slideSpeed: 300,
    slinkyNav: null,
    scrolly: 0,

    attach: function () {
      // console.log('Northstar menu.js loaded');

      // Mobile menu drill down navigation with Slinky initialization
      Northstar.menu.slinkyNav = $('.slinky-nav').slinky({resize: false, title: true});
      $('.slinky-nav a[data-toggle]').on('click', Northstar.menu.resetSlinky);

      // Tablet/Desktop menu sticky behavior
      var slimTitle = $('[data-page-title]').data('page-title') !== '' ? $('[data-page-title]').data('page-title') : $('[data-page-title]').html();
      if (typeof slimTitle != 'undefined') {
        $('.navbar-title').append('<span>' + slimTitle + '</span>');
      }
        $(window).on('load resize scroll', function () {

        Northstar.menu.scrolly = $(window).scrollTop();
        requestAnimationFrame(Northstar.menu.sticky);
      });

      // Desktop menu hover delays and display of third level items
      $('.navbar-menu .dropdown-onhover').hover(Northstar.menu.hoverMain);
      $('.navbar-menu .has-children').hover(Northstar.menu.hoverSecond);

      // Desktop top menu hover delays
      $('.topbar .dropdown-onhover').hover(Northstar.menu.hoverTop);

      // Toggler for mobile menu
      $('.navbar-toggler').on('click', Northstar.menu.toggleExpand);

      // Search menu expansion & closing
      $('.search-form .btn').on('click', Northstar.menu.searchExpand);
      $('.search-form .btn-close').on('click', Northstar.menu.searchClose);

      // Search predictive results
      $('.search-form .form-control').on('focus keyup', function (event) {
        // Ignore enter, escape, space.
        if (event.keyCode !== '13' && event.keyCode !== '27' && event.keyCode !== '32') {
          if (Northstar.menu.searchTimer) {
            clearTimeout(Northstar.menu.searchTimer);
          }
          Northstar.menu.searchTimer = setTimeout(Northstar.menu.searchPredict, 400);
        }
      });
      $('.search-form').on('click', function (e) {
        e.stopPropagation();
      });
      $('body').on('click', function () {
        Northstar.menu.searchClear(true);
      });

      // Share icons for fixed menu
      if ($('.byline .share').length) {
        $('.share-popover > a').popover('dispose');
        var share = $('.byline .share').clone();
        $('.navbar-topright .inner').prepend(share);
        $('.navbar-topright .share-popover > a').data('popover-top', true);
        $('.share-popover > a').each(Northstar.global.popover);
      }

      // Tooltips for fixed menu
      $('.navbar-topright [data-toggle="tooltip"]').tooltip({
        container: 'body', //.navbar-topright .inner',
        offset: '0,5px',
        placement: 'bottom',
        template: '<div class="tooltip tooltip-share" role="tooltip"><div class="tooltip-inner"></div></div>'
      });

      // Jump menu links for mobile
      if ($('nav.jump-links').not('.jump-links--fixed').length) {
        Northstar.menu.mobileJumplinks($('nav.jump-links').not('.jump-links--fixed'));
      }
    },

    searchClear: function (blur) {
      if (typeof blur != 'undefined') {
        $('.navbar-wrap .search-form .form-control').blur();
      }
      $('.navbar-wrap .search-results').empty().hide();
    },

    searchExpand: function (e) {
      if (!$('.navbar-wrap').hasClass('search-open')) {
        e.preventDefault();
        $('.navbar-wrap').addClass('search-open');
        $('.navbar-wrap .btn-search').tooltip('hide').tooltip('disable');
        $('.navbar-wrap .search-form .form-control').val('');
        $('.navbar-wrap .search-form .form-control').focus();
        Northstar.menu.setTop();
      }
    },

    searchClose: function (e) {
      if (typeof e != 'undefined') {
        e.preventDefault();
      }
      $('.navbar-wrap').removeClass('search-open');
      $('.navbar-wrap .btn-search').tooltip('enable');
      Northstar.menu.setTop();
      Northstar.menu.searchClear();
    },

    searchPredict: function () {
      var searchText = $('.navbar-wrap .search-form .form-control').val(),
        searchResults = $('.navbar-wrap .search-results');
      if (searchText.length >= 3) {
        Northstar.menu.searchClear();
        // TBD: Make an ajax call to fetch results.
        // $('.navbar-wrap .search-results').load('/', function () {
        //   searchResults.slideDown(250);
        // });
        //
        // SAMPLE DATA: remove after the ajax part is completed above.
        searchResults.html(
          '<ul><li><a href="#"><b>Boca</b> Chica, Dominican Republic</a></li><li><a href="#"><b>Boca</b> de Huergano, Spain</a></li><li><a href="#"><b>Boca</b> de la Vinorama, Baja California Sur, Mexico</a></li><li><a href="#"><b>Boca</b> de Tomatian, Jalisco, Mexico</a></li><li><a href="#"><b>Boca</b> del Rio, Veracruz, Mexico</a></li><li><a href="#"><b>Boca</b> Grande, Florida</a></li><li><a href="#"><b>Boca</b> Pointe, Florida</a></li></ul>'
        );
        searchResults.slideDown(250);
      }
    },

    toggleExpand: function (e) {
      e.preventDefault();
      $('.navbar-wrap').toggleClass('expanded');
      if ($('.navbar-wrap').hasClass('expanded')) {
        $(this).attr('aria-expanded', 'true');
        Northstar.menu.open();
      }
      else {
        $(this).attr('aria-expanded', 'false');
        Northstar.menu.close();
      }
    },

    setTop: function () {
      var size = getResponsiveBreakpoint(),
        target = $('.navbar-set-top'),
        height = $('.navbar').outerHeight();
      if (size == 'xs' || size == 'sm') {
        height += 68; // can't trust this -> $('.navbar-topright').height();
      }
      target.css({
        top: height,
        paddingBottom: height
      });
    },

    open: function () {
      var size = getResponsiveBreakpoint(),
        target = $('.navbar-slide-all, .navbar-slide-' + size);
      Northstar.menu.setTop();
      $(target).css({left: -$('.navbar-slide-all').width(), display: 'block'});
      $(target).animate({left: 0}, Northstar.menu.slideSpeed);
      if (size == 'xs' || size == 'sm') {
        $('.navbar-wrap').addClass('search-open');
      }
    },

    close: function (speed) {
      var target = $('.navbar-slide-all, .navbar-slide-sm');
      speed = (typeof speed != 'undefined') ? speed : Northstar.menu.slideSpeed;
      $(target).animate({left: -$('.navbar-slide-all').width()}, speed, function () {
        $(this).removeAttr('style');
      });
    },

    resetSlinky: function () {
      // Need to scrolltop the Slinky menu
      $('.slinky-nav-wrap').scrollTop(0);
    },

    reset: function () {
      Northstar.menu.close(0);
      Northstar.menu.searchClose();
      $('.navbar-wrap').removeClass('expanded');
      $('.navbar-toggler').attr('aria-expanded', 'false');
    },

    sticky: function () {
      var size = getResponsiveBreakpoint(),
        scrolly = Northstar.menu.scrolly,
        headerHeight = 352,
        animate = false,
        jumplinks = true,
        menuSize = 'menu-clp';  // Default collapsed, menu-clp menu-fxd menu-exp

      // Medium size, always fixed
      if (size == 'md') {
          menuSize = 'menu-fxd';      //768 - 929
      }
      else if (size == 'lg'  || size == 'xl') {     //930+
        if (scrolly > headerHeight) {
          menuSize = 'menu-fxd';
          animate = true;
        }
        else {
          menuSize = 'menu-exp';
        }
      }

      // Check if the menu size has changed, if so, run our adjustments
      if (!$('body').hasClass(menuSize)) {
        $('body').removeClass('menu-clp menu-fxd menu-exp');
        $('body').addClass(menuSize);
        Northstar.menu.reset();
        if (animate) {
          jumplinks = false;
          $('.navbar-wrap').css('top', -Northstar.menu.getFxdmenuH());
          $('.navbar-wrap').animate({top: 0}, Northstar.menu.slideSpeed, function () {
            $(this).removeAttr('style');
            Northstar.menu.stickyJumplinks(menuSize, animate);
          });
        }
      }

      // Jump links
      if (jumplinks) {
        Northstar.menu.stickyJumplinks(menuSize);
      }

    },

    stickyJumplinks: function (menuSize, animate) {
      if (!$('nav.jump-links').length) {
        return;
      }

      var links = $('nav.jump-links').not('.jump-links--mobile'),
        linksClone = $('nav.jump-links--fixed'),
        offset = links.offset(),
        menuHeight = Northstar.menu.getFxdmenuH(),
        scrolly = Northstar.menu.scrolly;

      if (menuSize != 'menu-clp' && offset.top - menuHeight <= scrolly) {
        if (!linksClone.length) {
          linksClone = links.clone(true);
          linksClone.removeClass('d-none d-md-block');
          linksClone.addClass('jump-links--fixed').insertAfter(links);
        }
        linksClone.css({top: menuHeight, left: 0});
        if (typeof animate !== 'undefined') {
          linksClone.slideDown(Northstar.menu.slideSpeed);
        }
        else {
          linksClone.show();
        }
      }
      else {
        linksClone.hide();
      }
    },

    hoverMain: function (e) {
      clearTimeout(Northstar.menu.menuTimer);
      var li = $(this);

      if (e.type === 'mouseenter') {
        Northstar.menu.menuTimer = setTimeout(function () {
          $('.dropdown-onhover.hover').removeClass('hover');
          li.addClass('hover');
          Northstar.menu.searchClear(true);
          Northstar.menu.reposition($('.dropdown-menu', li));
        }, Northstar.menu.openDelay);
      }
      else {
        Northstar.menu.menuTimer = setTimeout(function () {
          $('.navbar-menu .dropdown-onhover').removeClass('hover');
        }, Northstar.menu.closeDelay);
      }
    },

    hoverSecond: function (e) {
      clearTimeout(Northstar.menu.submenuTimer);
      var li = $(this),
          target = $(this).parent().parent().next('.dropdown-right-col'),
          links = $(this).children('.dropdown-children'),
          minWidth = target.outerWidth(),
          minHeight = links.outerHeight();

      if (e.type === 'mouseenter') {
        Northstar.menu.submenuTimer = setTimeout(function () {
          $('.has-children.hover').removeClass('hover');
          li.addClass('hover');
          target.addClass('hidden').css('minHeight', minHeight);
          links.css('minWidth', minWidth);
        }, Northstar.menu.openDelay);
      }
      else {
        Northstar.menu.submenuTimer = setTimeout(function () {
          li.removeClass('hover');
          target.removeClass('hidden').removeAttr('style');
          links.removeAttr('style');
        }, Northstar.menu.closeDelay);
      }
    },

    hoverTop: function (e) {
      clearTimeout(Northstar.menu.topmenuTimer);
      var li = $(this);

      if (e.type === 'mouseenter') {
        Northstar.menu.topmenuTimer = setTimeout(function () {
          $('.dropdown-onhover.hover').removeClass('hover');
          li.addClass('hover');
        }, Northstar.menu.openDelay);
      }
      else {
        Northstar.menu.topmenuTimer = setTimeout(function () {
          $('.topbar .dropdown-onhover').removeClass('hover');
        }, Northstar.menu.closeDelay);
      }
    },

    reposition: function (el) {
      el.removeAttr('style');
      var left = el.parent().position().left,
        menu = el.width(),
        width = $('.navbar').width();
      if (left + menu > width) {
        el.css('marginLeft', -menu + (width - left));
      }
    },

    mobileJumplinks: function (el) {
      var links = el,
        mobileLinks = el.clone(true),
        label = $('<a href="#" class="jump-links--toggle">' + $('a', links).eq(0).text() + '</a>');
      links.addClass('d-none d-md-block');
      mobileLinks.prepend(label).addClass('jump-links--mobile d-block d-md-none');
      mobileLinks.insertAfter(links);
      label.on('click', function (e) {
        e.preventDefault();
        $(this).next().toggle();
        $(this).toggleClass('open');
      });
      $('ul a', mobileLinks).on('click', function () {
        $(this).parent().parent().prev().trigger('click');
      });
    },

    getFxdmenuH: function () {
      var minFxdmenuH = 80;
      if ($('body').hasClass('menu-fxd') || $('body').hasClass('menu-clp')) {
        minFxdmenuH = $('.navbar-wrap').height();
      }
      return minFxdmenuH;
    }
  };

  // Initialize our app on document ready
  $(document).ready(Northstar.menu.attach);

}(jQuery, this, this.document));
